import { render, staticRenderFns } from "./DoughNut3.vue?vue&type=template&id=4b87c54f&scoped=true"
import script from "./DoughNut3.vue?vue&type=script&lang=js"
export * from "./DoughNut3.vue?vue&type=script&lang=js"
import style0 from "./DoughNut3.vue?vue&type=style&index=0&id=4b87c54f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b87c54f",
  null
  
)

export default component.exports